import { FscOrderSummary } from 'pricing-pages-ui-components/fsc-configure/FscOrderSummary';
import PublicCurrencyPicker from '../../components/PublicCurrencyPicker';
import { PublicFscCheckoutCtas } from './PublicFscCheckoutCtas';
import { jsx as _jsx } from "react/jsx-runtime";
export function PublicFscOrderSummary({
  content,
  checkoutCtas
}) {
  return /*#__PURE__*/_jsx(FscOrderSummary, {
    content: content,
    currencyPicker: /*#__PURE__*/_jsx(PublicCurrencyPicker, {}),
    checkoutCta: /*#__PURE__*/_jsx(PublicFscCheckoutCtas, {
      ctas: checkoutCtas
    })
  });
}